import {
  Flex,
  Text,
  Spacer,
  Button,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure
} from '@chakra-ui/react'
import { FC } from 'react'
import { FaBezierCurve } from 'react-icons/fa'

import useOptimizerStorange from '@hook/optimizer/use-optimizer-storange'

interface SelectedTableBarProps {
  levelSelection: string
  curve?: string
}
const SelectedTableBar: FC<SelectedTableBarProps> = ({
  levelSelection,
  curve
}) => {
  const { saveOtimizer } = useOptimizerStorange()
  const { isOpen, onOpen, onClose } = useDisclosure()
  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={4}
    >
      <Box pl={4}>
        <FaBezierCurve size={40} color="#55a060" />
      </Box>
      <Flex justifyContent="center" alignItems="center">
        <Flex>
          <Box margin="0 20px">
            <Text fontWeight="900" marginBottom="2px">
              Nivel de Selecao
            </Text>
            <Text>{levelSelection}</Text>
          </Box>
          {curve !== null && (
            <>
              <Box margin="0 20px">
                <Text fontWeight="900" marginBottom="2px">
                  Curva
                </Text>
                <Text>{curve}</Text>
              </Box>
            </>
          )}
        </Flex>
      </Flex>
      <Spacer />
      <>
        {curve === null && (
          <>
            <Box pr={2}>
              <Button
                fontSize={14}
                size="sm"
                color="#4b64c9"
                borderRadius={5}
                border="1px solid #4b64c9"
                cursor="pointer"
                // disabled={selecteds.length === 0}
                transition="all ease .2s"
                _hover={{
                  background: '#c0d9ff',
                  color: '#2d3b72'
                }}
                onClick={onOpen}
              >
                Salvar
              </Button>
            </Box>
          </>
        )}
      </>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            Ponto Selecionado
          </ModalHeader>
          <ModalCloseButton
            top={1}
            right={1.5}
            textColor={'gray.200'}
            size="lg"
          />
          <ModalBody>
            <Text>
              Deseja salvar as políticas de estoque otimizadas? <br></br>
              Uma mensagem de aviso informará o término desta operação.,{' '}
              <br></br>
              Otimização das políticas de estoque Você selecionou o{' '}
              <b>{levelSelection}</b>
              <br></br>
              Voce desejar utilizar esse ponto como otimizador
              <br></br>
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="green"
              onClick={() => {
                saveOtimizer(levelSelection)
                onClose()
              }}
            >
              Continuar
            </Button>
            <Button colorScheme="red" onClick={onClose} ml={3}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  )
}

export default SelectedTableBar
